import { useRef, useEffect, useState } from 'react';

export default function BloomerangPaymentElement({ adapter }) {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mountedRef = useRef(false);

  useEffect(() => {
    if (!adapter || !containerRef.current) return;

    mountedRef.current = true;

    try {
      adapter.mountPaymentElement(containerRef.current);

      // Poll for Stripe Payment Element to appear in the container.
      // Check for iframe, or any Stripe-rendered content (div with children).
      var resolved = false;
      var checkInterval = setInterval(() => {
        if (!mountedRef.current) return;
        var container = containerRef.current;
        if (!container) return;

        var hasStripeContent = container.querySelector('iframe') ||
          container.querySelector('[class*="Element"]') ||
          container.querySelector('#card-element > *');

        if (hasStripeContent) {
          resolved = true;
          setLoading(false);
          clearInterval(checkInterval);
        }
      }, 300);

      // Timeout — clear loading state so the form is usable even if
      // detection missed. Don't show an error since the element may
      // have loaded fine (the detection heuristic isn't perfect).
      var timeout = setTimeout(() => {
        clearInterval(checkInterval);
        if (!resolved && mountedRef.current) {
          setLoading(false);
        }
      }, 30000);

      return () => {
        mountedRef.current = false;
        clearInterval(checkInterval);
        clearTimeout(timeout);
        adapter.cleanup();
      };
    } catch (err) {
      setError(err.message || 'Failed to load payment form');
      setLoading(false);
    }
  }, [adapter]);

  return (
    <div>
      {loading && (
        <div style={{ padding: '20px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
          Loading payment form...
        </div>
      )}
      {error && (
        <div style={{ padding: '12px', color: '#900', fontSize: '14px', border: '1px solid #900', borderRadius: '6px', marginBottom: '12px' }}>
          {error}
        </div>
      )}
      <div
        ref={containerRef}
        style={{ display: loading ? 'none' : 'block' }}
      />
    </div>
  );
}
